// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  mailId: __t.u64().name("mail_id"),
  fromPlayerId: __t.string().name("from_player_id"),
  fromDisplayName: __t.string().name("from_display_name"),
  toPlayerId: __t.string().name("to_player_id"),
  toDisplayName: __t.string().name("to_display_name"),
  msg: __t.string(),
  trade: __t.string(),
  read: __t.bool(),
  timeSent: __t.timestamp().name("time_sent"),
});
